import CreateButton from '../CreateButton';
import GS from '../../grafsync/grafsync';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import BackupIcon from '@material-ui/icons/Backup';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import CancelButton from '../CancelButton';
import PrimaryButton from '../PrimaryButton';
import { globalStyles as styles } from '../style/gstheme';
import TitledTextField from '../TitledTextField';
import { fullySanitiseText } from '../utils/utils';

class TakeSnapshotDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            isVersion: props.isVersion,
            allowVersions: GS.getActiveSubscriptionType() === "Managed" || GS.getActiveSubscriptionType() === "Trial" || GS.getActiveSubscriptionType() === "Premium",
            name: "",
            comment: ""
        };
        this.cancellable = null;
        this.textInput = React.createRef();
    }

    handleClickOpen = () => this.setState({ open: true, name: "", comment: "", isVersion: this.props.isVersion });

    takeSnapshot = () => {
        this.exitTakeSnapshot();
        this.props.onTakeSnapshot({
            name: this.state.name.trim(),
            comment: this.state.comment.trim(),
            isVersion: this.state.isVersion
        });
    };

    exitTakeSnapshot = () => this.setState({ open: false });

    handleChange = (event) => {
        const t = event.target;
        const cleanText = fullySanitiseText(t.value);
        this.setState({ [event.target.name]: cleanText });
    };

    handleChangeIsVersion = (event) => this.setState({ isVersion: event.target.checked });

    render() {

        const { name, comment, isVersion, allowVersions } = this.state;
        const { classes, title, button } = this.props;

        return (
            <React.Fragment>
                {button ?
                    <CreateButton onClick={this.handleClickOpen} label={title} />
                    :
                    <Tooltip title={title}>
                        <IconButton data-test="take-snapshot" size="medium" onClick={this.handleClickOpen}>
                            <BackupIcon fontSize='medium' />
                        </IconButton>
                    </Tooltip>
                }
                <Dialog
                    data-test="add-snapshot-dialog"
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paperWidthMd: classes.mediumDialog
                    }}
                    className={classes.dialog}
                    open={this.state.open}
                    onClose={this.exitAddLiteral} aria-labelledby="addsnapshot-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="addsnapshot-dialog-title">{
                        this.props.isVersion ?
                            "Create Version"
                            :
                            "Take Snapshot"
                    }</DialogTitle>
                    <DialogContent>
                        <form autoComplete="off" noValidate="novalidate">
                            <div style={{ marginBottom: 20 }}>
                                <TitledTextField
                                    dataTest="snapshot-name"
                                    name="name"
                                    title="Name"
                                    autoFocus
                                    inputRef={this.textInput}
                                    text={name}
                                    placeholder={this.props.isVersion ? "Give your version a name" : "Give your snapshot a name"}
                                    maxLength={100}
                                    onChange={this.handleChange} />
                                <TitledTextField
                                margin
                                    dataTest="snapshot-comment"
                                    name="comment"
                                    title="Comment"
                                    text={comment}
                                    multiline={true}
                                    placeholder="Add some additional information"
                                    maxLength={500}
                                    onChange={this.handleChange} />
                                {allowVersions && !this.props.isVersion &&
                                    <FormControlLabel
                                        data-test="option-label"
                                        control={
                                            <Checkbox data-test="is-version" checked={isVersion} onChange={this.handleChangeIsVersion} name="isVersion" />
                                        }
                                        label="Set as Version"
                                        classes={{ label: classes.formLabelInlineLightLarge }}
                                    />
                                }
                            </div>
                        </form>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitTakeSnapshot}>Cancel</CancelButton>
                        <PrimaryButton dataTest="execute" onClick={this.takeSnapshot}>Execute</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

TakeSnapshotDialog.defaultProps = {
    title: "Take snapshot",
    isVersion: false,
    button: false
};

TakeSnapshotDialog.propTypes = {
    classes: PropTypes.object,
    isVersion: PropTypes.bool,
    button: PropTypes.bool,
    onTakeSnapshot: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired
};

export default withStyles(styles)(TakeSnapshotDialog);
